<template lang="pug">
v-container.pa-0(grid-list-xl, fluid)
  v-layout(wrap)
    .tools
      v-flex(xs12)
        v-btn.ml-0(
          :outline='!(block.meta.variant === "h2")',
          @click='format("h2")',
          active,
          color='primary',
          small,
          icon
        )
          b H2
        v-btn(
          :outline='!(block.meta.variant === "h3")',
          @click='format("h3")',
          color='primary',
          small,
          icon
        )
          b H3
        v-btn(
          :outline='!(block.meta.variant === "h4")',
          @click='format("h4")',
          color='primary',
          small,
          icon
        )
          b H4
    v-flex(xs12)
      v-text-field(
        label='Заголовок',
        v-model='block.value',
        @input='$emit("update", block)'
      )
</template>

<script>
import BaseBlock from './BaseBlock'
export default {
  extends: BaseBlock,
  methods: {
    format(variant) {
      this.block.meta.variant = variant
      this.$emit('update', this.block)
    },
  },
}
</script>

<style scoped>
.tools {
  margin-bottom: -24px;
}
</style>